"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getReferrerLink;
const context_1 = require("@apollo/client/link/context");
const exenv_1 = require("exenv");
let referrer = null;
/**
 * Link that overrides the referrer information in all requests made.
 * @param initialReferrer the referrer value
 */
function getReferrerLink(router, initialReferrer) {
    var _a;
    if (referrer == null) {
        referrer = initialReferrer;
    }
    if (exenv_1.canUseDOM) {
        if (!referrer) {
            // eslint-disable-next-line prefer-destructuring
            referrer = document.referrer;
        }
        (_a = router === null || router === void 0 ? void 0 : router.events) === null || _a === void 0 ? void 0 : _a.on('routeChangeStart', () => {
            // eslint-disable-next-line prefer-destructuring
            referrer = document.location.href;
        });
    }
    return (0, context_1.setContext)((_1, _a) => __awaiter(this, [_1, _a], void 0, function* (_, { headers }) {
        return {
            headers: Object.assign({ ['kh-referrer']: referrer }, headers)
        };
    }));
}
//# sourceMappingURL=referrerLink.js.map